var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 22.0001,
    height: 22.0002,
    viewBox: "0 0 22.0001 22.0002",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.89813 16.9615C2.95582 16.751 2.82938 16.4582 2.7087 16.2471C2.6713 16.1841 2.63053 16.1231 2.58659 16.0644C1.55162 14.4948 0.999984 12.6561 1.00005 10.776C0.982743 5.37933 5.45774 1 10.9914 1C15.8174 1 19.8462 4.34327 20.7871 8.78125C20.9283 9.43921 20.9997 10.1102 21.0001 10.7832C21.0001 16.1875 16.6976 20.6356 11.164 20.6356C10.2837 20.6356 9.09669 20.4144 8.44909 20.2332C7.80149 20.0519 7.15486 19.8115 6.98803 19.7471C6.81725 19.6815 6.63588 19.6478 6.45294 19.6476C6.25344 19.6469 6.05587 19.6866 5.87217 19.7644L2.61063 20.9413C2.53936 20.9721 2.46381 20.9919 2.38659 21C2.32551 20.9998 2.26507 20.9875 2.20877 20.9638C2.15247 20.9401 2.10143 20.9055 2.0586 20.862C2.01577 20.8184 1.98199 20.7668 1.95924 20.7101C1.93648 20.6534 1.92519 20.5928 1.92601 20.5317C1.93002 20.4781 1.93969 20.4251 1.95486 20.3736L2.89813 16.9615Z",
    stroke: "#45474C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.04aa913a2235e3833c5a7ad416285e7e.svg";
export { ForwardRef as ReactComponent };